/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import Api from "../Api";
import Auth from "./Auth";

export default class AuthDefault implements Auth {

   constructor(
      protected config: any,
      protected api: Api
   ) {}


   public login(redirectUrl: string): Promise<void> {
      throw new Error("Not implemented!");
   }


   public logout(redirectUrl?: string): Promise<void> {
      throw new Error("Not implemented!");
   }

   public getAuthenticatedUser(): string | null {
      return this.api.user_id;
   }

   public getCurrentUserRoles(): string[] {
      return this.api.user_roles;
   }

   public getSessionExspirationTime(): number {
      return this.api.auth_expires;
   }

}